module.exports = __webpack_public_path__ + "img/s1_pic.d3fdebc1.png";